define(
	'AAMedical.ScopeRepair.EntryPoint'
,   [
		'AAMedical.ScopeRepair.FlexibleScopeRepair.View',
		'AAMedical.ScopeRepair.RigidScopeRepair.View',
		'AAMedical.ScopeRepair.ServiceYourScope.View'
	]
,   function (
		FlexibleScopeRepairView,
		RigidScopeRepairView,
		ServiceYourScopeView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var pageType = container.getComponent('PageType');

			if(pageType)
			{
				pageType.registerPageType({
					name: 'flexible-scope-repair-page',
					routes: ['flexible-scope-repair'],
					view: FlexibleScopeRepairView
				});

				pageType.registerPageType({
					name: 'rigid-scope-repair-page',
					routes: ['rigid-scope-repair'],
					view: RigidScopeRepairView
				});

				pageType.registerPageType({
					name: 'service-your-scope-page',
					routes: ['service-your-scope'],
					view: ServiceYourScopeView
				});
			}
		}
	};
});
